import React, { useEffect } from 'react';
import { getDealers } from 'src/bff';
import { TriggerProps, useFaContent, useGetDealers } from 'src/feature-app';
import { NuevaCitaPosventaFormController } from 'src/forms/CitaPosventa/NuevaCitaPosventa';
import { FormDataFields } from 'src/types';

export function CitaPosventaActionForm({ setSelectedJourney }: TriggerProps) {
	const faContent = useFaContent();
	const { loading } = useGetDealers(faContent?.kvpsCode);

	const renderForm = (fields: FormDataFields) => {
		setSelectedJourney(
			<NuevaCitaPosventaFormController
				updatedFormData={{
					fields,
				}}
			/>,
			true,
		);
	};
	useEffect(() => {
		if (loading) return;

		const fields = {
			motivo: faContent.motivo ?? null,
			formName: 'cita-posventa',
		};

		getDealers()
			.then(() => {
				renderForm({ ...fields });
			})
			.catch(err => {
				renderForm({ ...fields }); // Hay que ver que hacer en estos casos.
			});
	}, [loading]);

	return <></>;
}
